const trainers = [
  {
    name: "By Manikonda Sharat",
    course: "Network Analytics Part 1",
    demoVideo: "https://www.youtube.com/watch?v=PGeBdvgYVNA&list=PLfuvcZwtz-hhjIxnLKGMSgxVLOwCIGsob&index=1",
    paidVideos: [
      "https://www.youtube.com/watch?v=I1YvJDOWITE&list=PLfuvcZwtz-hhjIxnLKGMSgxVLOwCIGsob&index=2",
      "https://www.youtube.com/watch?v=ZBBFi2mNJhA&list=PLfuvcZwtz-hhjIxnLKGMSgxVLOwCIGsob&index=3"
    ]
  },
  {
    name: "By Manikonda Sharat",
    course: "Data Structure & Algorithm",
    demoVideo: "https://www.youtube.com/embed/qT2U8TG5u6s",
    paidVideos: [
      "https://www.youtube.com/embed/gxitrRvyBy",
      "https://www.youtube.com/embed/Vl-ZDO9vyH8"
    ]
  },
  {
    name: "By Sharat Manikonda",
    course: "Apache Spark Intro",
    demoVideo: "https://www.youtube.com/embed/gxitrRvyByc",
    paidVideos: [
      "https://www.youtube.com/embed/dummy_paid1",
      "https://www.youtube.com/embed/dummy_paid2"
    ]
  },
  {
    name: "By Deepak .B",
    course: "Demo of Power BI",
    demoVideo: "hhttps://www.youtube.com/watch?v=PM1v7CfJy0U",
    paidVideos: [
      "https://www.youtube.com/embed/dummy_paid1",
      "https://www.youtube.com/embed/dummy_paid2"
    ]
  },
  {
    name: "By Sharat Manikonda",
    course: "Python Programming with 10 Years kid",
    demoVideo: "https://www.youtube.com/watch?v=6v-f-pk0vNI&list=PLfuvcZwtz",
    paidVideos: [
      "https://www.youtube.com/embed/dummy_paid1",
      "https://www.youtube.com/embed/dummy_paid2"
    ]
  }
  
  // {
    
  //   // name: "By Manikonda Sharat",
  //   // course: "Python Programming with 10 Years kid",
  //   // demovideo: "https://www.youtube.com/watch?v=6v-f-pk0vNI",
  //   // paidVideos: [
  //   //   "https://www.youtube.com/embed/dummy_paid1",
  //   //   "https://www.youtube.com/embed/dummy_paid2"
  //   // ]
  // }

];

export default trainers; 
